<template>
  <b-container>
    <b-list-group>
      <b-list-group-item v-for="item in list" :active="item === activeConfig" :to="{name: 'PredictionConfig', params:{configId: item}}">{{item}}</b-list-group-item>
    </b-list-group>
  </b-container>
</template>

<script>
import * as PredictionConfigList from '../models/PredictionConfigList'
export default {
  name: 'PredictionConfigList',
  props: [],
  data () {
    return {
      dataLoaded: false,
      list: [],
      activeConfig: ""
    }
  },
  methods: {
    loadConfigList: function() {
      this.activeConfig = this.$route.params.configId
      return PredictionConfigList.load()
      .then(response => {
        this.dataLoaded = true
        this.list = response.map(item => item.split("/")[item.split("/").length - 1].replace(".json",""))
      })
      .catch(err => {
      })
    }
  },
  watch: {
    $route(to, from) {
      //if (to.name === "PredictionConfigList" || this.name === "PredictionConfig") //this.loadConfigList()
    }
  },
  activated () {
    console.log('mounted')
    this.loadConfigList()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group-item.active {
  background-color: #06965A
}
</style>
